var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.block)?_c('BlockListExperts',_vm._b({key:_vm.block.key},'BlockListExperts',_vm.block.content,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }